var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTradeFinance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10.5898H12.5C11.1217 10.5898 10 11.7115 10 13.0898V26.4232C10 27.8015 11.1217 28.9232 12.5 28.9232H27.5C28.8783 28.9232 30 27.8015 30 26.4232V13.0898C30 11.7115 28.8783 10.5898 27.5 10.5898ZM27.5 27.2565H12.5C12.0408 27.2565 11.6667 26.8832 11.6667 26.4232V14.7565H28.3333V26.4232C28.3333 26.8832 27.9592 27.2565 27.5 27.2565Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1675 17.2539C23.2483 17.2539 22.5008 18.0014 22.5008 18.9206C22.5008 19.2156 22.5841 19.4889 22.7191 19.7289L21.3075 21.4972C21.1566 21.4522 21 21.4206 20.8341 21.4206C20.4141 21.4206 20.035 21.5814 19.7416 21.8389L17.4875 20.7189C17.5691 19.6964 16.7625 18.9206 15.8341 18.9206C14.915 18.9206 14.1675 19.6681 14.1675 20.5872C14.1675 21.5064 14.915 22.2539 15.8341 22.2539C16.2541 22.2539 16.6333 22.0931 16.9266 21.8356L19.1808 22.9556C19.1775 22.9997 19.1675 23.0422 19.1675 23.0872C19.1675 24.0064 19.915 24.7539 20.8341 24.7539C21.7533 24.7539 22.5008 24.0064 22.5008 23.0872C22.5008 22.7922 22.4175 22.5189 22.2825 22.2789L23.6941 20.5106C24.8066 20.8431 25.8341 19.9956 25.8341 18.9206C25.8341 18.0014 25.0866 17.2539 24.1675 17.2539Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTradeFinance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_trade_finance.f44b6c9167dccdfedf72d73b2aa91c86.svg";